//import { useRoute } from 'vue-router';

export interface AppConfig
{
  apiBaseUrl: string
  productPageBaseUrl: string
  productImageBaseUrl: string
  runMode: 'dev' | 'prod' | 'test'
}

export async function loadConfig(configUrl?: string): Promise<AppConfig>
{
  /* Somthing like this can be used to set root URL when app is embedded:
  <script>
    window.APP_ROOT_URL = '{{rootUrl}}';
  </script>  
  */

  //const rootUrl = window.APP_ROOT_URL || '' // default: in vue /public folder
  if (!configUrl)
  {
    configUrl = '/config.json' // default: in vue /public folder
  }

  const res = await fetch(configUrl);
  if (!res.ok) throw new Error('Failed to load config')
  const config = (await res.json()) as AppConfig

  console.log('Config loaded:', config);

  return config
}

